<template>
  <div class="form form-card">
    <div class="form-card__container form-card__container--sm">
      <el-form
        ref="MemberForm"
        class="change-password-form"
        :model="MemberForm"
        :rules="MemberRules"
        @submit.prevent.native
      >
        <el-form-item prop="memberPassword" class="form-field">
          <label class="form-label">{{ $t('changePassword.label.oldPassword') }}</label>
          <el-input
            v-model="MemberForm.memberPassword"
            :placeholder="$t('changePassword.placeholder.oldPassword')"
            type="password"
            show-password
            size="large"
            prefix-icon="el-icon-lock"
          />
        </el-form-item>

        <el-form-item prop="memberNewPassword" class="form-field">
          <label class="form-label">{{ $t('changePassword.label.newPassword') }}</label>
          <el-input
            v-model="MemberForm.memberNewPassword"
            :placeholder="$t('changePassword.placeholder.newPassword')"
            type="password"
            show-password
            size="large"
            prefix-icon="el-icon-lock"
          />
        </el-form-item>

        <el-form-item prop="memberConfirmPassword" class="form-field">
          <label class="form-label">{{ $t('changePassword.label.confirmPassword') }}</label>
          <el-input
            v-model="MemberForm.memberConfirmPassword"
            :placeholder="$t('changePassword.placeholder.confirmPassword')"
            type="password"
            show-password
            size="large"
            prefix-icon="el-icon-lock"
          />
        </el-form-item>

        <button
          class="btn-submit full"
          @click="ModifyMemberPassword"
        >
          {{ $t('common.button.submit') }}
        </button>
      </el-form>
    </div>
  </div>
</template>

<script>
import { ModifyMemberPassword } from '@/api/MemberApi';

export default {
  data() {
    return {
      MemberForm: {
        memberPassword: '',
        memberNewPassword: '',
        memberConfirmPassword: '',
      },
      MemberRules: {
        memberPassword: [{ required: true, message: this.$t('validation.oldPasswordRequired'), trigger: 'blur' }],
        memberNewPassword: [
          { required: true, message: this.$t('validation.newPasswordRequired'), trigger: 'blur' },
          { min: 6, max: 20, message: this.$t('validation.passwordLength') },
          {
            pattern: /^([a-zA-Z]+\d+|\d+[a-zA-Z]+)[a-zA-Z0-9]*$/,
            message: this.$t('validation.alphanumeric'),
            trigger: 'blur',
          },
        ],
        memberConfirmPassword: [
          { required: true, message: this.$t('validation.confirmPasswordRequired'), trigger: 'blur' },
          { min: 6, max: 20, message: this.$t('validation.passwordLength') },
          {
            pattern: /^([a-zA-Z]+\d+|\d+[a-zA-Z]+)[a-zA-Z0-9]*$/,
            message: this.$t('validation.alphanumeric'),
            trigger: 'blur',
          },
        ],
      },
    };
  },
  created() {
  },
  methods: {
    ModifyMemberPassword() {
      this.$refs.MemberForm.validate((valid) => {
        if (valid) {
          ModifyMemberPassword(this.MemberForm).then((response) => {
            if (response.data.statusCode === 0) {
              this.$message({
                showClose: true,
                type: 'success',
                message: this.$t('changePassword.message.success'),
              });
              this.MemberForm.memberPassword = '';
              this.MemberForm.memberNewPassword = '';
              this.MemberForm.memberConfirmPassword = '';
            }
          });
        } else {
          this.$message({
            showClose: true,
            type: 'error',
            message: this.$t('common.message.fillAllFields'),
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
